package top.wcpe.allincore.ui.runtime.ir.call

import top.wcpe.allincore.dsl.ir.expr.ExprNode
import top.wcpe.allincore.dsl.ir.expr.StmtNode

/**
 * 运行期 lambda 值。
 *
 * 携带形参名、body 与构造时按值捕获的外层 var 快照。
 *
 * 调用语义详见 [CallDispatcher.invokeLambda]。
 *
 * M5-b：新增 `defaults` 字段——与 [params] 等长的默认值表达式列表，
 * 元素 `null` 表示该形参无默认值；空列表表示全部无默认值（兼容旧路径）。
 */
data class LambdaValue(
    val params: List<String>,
    val body: List<StmtNode>,
    val captured: Map<String, Any>,
    val isSuspend: Boolean = false,
    // 元素可空：形参无默认值时对应位置为 null（与 IR ExprNode.Lambda.defaults 对齐）。
    val defaults: List<ExprNode?> = emptyList(),
) {
    init {
        require(defaults.isEmpty() || defaults.size == params.size) {
            "lambda defaults 长度与 params 不一致"
        }
    }

    override fun toString(): String {
        val prefix = if (isSuspend) "SuspendLambdaValue" else "LambdaValue"
        return "$prefix(params=$params, capturedKeys=${captured.keys})"
    }
}
